// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1eqON","choiceBoxes":"toolbarselects_choiceBoxes__3O8QO","simpleField":"toolbarselects_simpleField__2HE2V"};